import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { environment } from '../../../../app-environments/environment';
import { AddressService } from '../../services/address.service';
import { SERVICE_PROVIDER } from '../../services/fee.service';

@Component({
  selector: 'app-application-confirmation',
  templateUrl: './application-confirmation.component.html',
  styleUrls: ['./application-confirmation.component.css']
})
export class ApplicationConfirmationComponent implements OnInit {

  isLand = false;
  DAMSApplicationId: string;
  linkTitle: string;
  linkToNextRoute: string;
  mailHref: string;
  workingDays = 10;
  showMonthlyAccountHolderMessage = true;
  showPayByChequeMessage = false;
  totalOrderAmount: number;
  sra: boolean = true
  cwwPricingZone: boolean = true;
  pricingZone: string = SERVICE_PROVIDER.CWW;

  redirectToCalendarly: boolean = false;
  countDownTimer: number = 5;

  constructor(private loginService: LoginService, private route: ActivatedRoute, 
    private router: Router, private addressService: AddressService) {
      // fetch pricing zone (CWW / WW)
    this.addressService.getPricingZone().subscribe(_pricingzone => {
      this.pricingZone = _pricingzone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      this.cwwPricingZone = this.pricingZone === SERVICE_PROVIDER.CWW;
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  ngOnInit() {
    this.DAMSApplicationId = this.route.snapshot.queryParams['DAMSApplicationId'];
    const appType = this.route.snapshot.queryParams['AppType'];
    const totalOrderAmount = this.route.snapshot.queryParams['TotalOrderAmount'];

    if (appType === 'srp') {
      this.linkTitle = 'Apply for single residential plumbing';
      this.linkToNextRoute = '/srp';
      this.mailHref = 'mailto:technicalenquiries@gww.com.au?Subject=Single%20residential%20plumbing%20enquiry';
    } 
    else if (appType === 'sdai') {
      this.linkTitle = 'Apply for sewer details and asset information';
      this.linkToNextRoute = '/sdai';
      this.mailHref = 'mailto:propertydevelopment@gww.com.au?Subject=Sewer%20details%20and/or%20asset%20information%20enquiry';
    }
    else if (appType === 'SRA') {
      this.linkTitle = ' Apply for Servicing Requirements Advice Application';
      this.linkToNextRoute = '/psa';
      this.mailHref = `mailto:SRA@gww.com.au?Subject= Ref# ${this.DAMSApplicationId} - Servicing%20Requirements%20Advice%20Enquiry`;
      this.sra = false
    }
    else if (appType === 'pfi') {
      this.linkTitle = 'Apply for pressure and flow information';
      this.linkToNextRoute = '/pfi';
      this.mailHref = 'mailto:design@gww.com.au?Subject=Pressure%20and%20flow%20information%20enquiry';
    } 
    else if (appType === 'boe') {
      this.linkTitle = 'Apply for building over easement';
      this.workingDays = 20;
      this.linkToNextRoute = '/boe';
      this.mailHref = 'mailto:buildover@gww.com.au?Subject=Building%20over%20easement%20enquiry';
    } 
    else if (appType === 'chm') {
      this.linkTitle = 'Application for the supply of potable and recycled check meters';
      this.workingDays = 15;
      this.linkToNextRoute = '/chm';
      this.mailHref = 'mailto:camsapplications@gww.com.au?Subject=Check%20meters%20application%20enquiry';
    } 
    else if (appType === 'usr') {
      this.linkTitle = 'Apply for urgent sewer repair notice';
      this.workingDays = 1;
      this.linkToNextRoute = '/usr';
      this.mailHref = 'mailto:technicalenquiries@gww.com.au?Subject=Urgent%20sewer%20repair%20notice%20enquiry';
    } 
    else if (appType === 'cmp') {
      this.linkTitle = 'Apply for commercial/multi unit plumbing';
      this.workingDays = 20;
      this.linkToNextRoute = '/cmp-nf';
      this.mailHref = 'mailto:complexplumbing@gww.com.au?Subject=Complex%20plumbing%20enquiry';
    } 
    else if (appType === 'lnd-w') {
      this.isLand = true;
      this.totalOrderAmount = totalOrderAmount;
      this.showMonthlyAccountHolderMessage = false;
      this.showPayByChequeMessage = true;
      this.linkTitle = 'Application to extend and/or upgrade a Greater Western Water sewer and/or water main';
      this.workingDays = 45;
      this.linkToNextRoute = '/lnd-w';
      this.mailHref = 'mailto:designs@gww.com.au?Subject=Development%20works%20application%20enquiry';
    } 
    else if (appType === 'rwi') {
      this.route.params.subscribe((routerParams: any) => {
        console.log(routerParams);
        this.redirectToCalendarly = [true, 'true'].indexOf(routerParams.calendlyRedirect) > -1;

        if (this.redirectToCalendarly) {
          this.redirect();
        }
      });
    }

    this.addressService.getPricingZone().subscribe(_pricingzone => {
      console.log(_pricingzone.toUpperCase());
      this.cwwPricingZone = (_pricingzone && _pricingzone.toUpperCase() === 'FMR CWW');
      this.setupEmail(appType);
    }, err => {});
  }

  get isGuestUserLoggedIn(): boolean {
    return this.loginService.isGuestUserLoggedIn();
  }

  setupEmail(appType: string): void {
    if(this.cwwPricingZone) {
      if (appType === 'srp') {
        this.mailHref = 'mailto:technicalenquiries@gww.com.au?Subject=Single%20residential%20plumbing%20enquiry';
      } else if (appType === 'sdai') {
        this.mailHref = 'mailto:propertydevelopment@gww.com.au?Subject=Sewer%20details%20and/or%20asset%20information%20enquiry';
      } else if (appType === 'SRA') {
        this.mailHref = `mailto:SRA@gww.com.au?Subject= Ref# ${this.DAMSApplicationId} - Servicing%20Requirements%20Advice%20Enquiry`;
      } else if (appType === 'pfi') {
        this.mailHref = 'mailto:design@gww.com.au?Subject=Pressure%20and%20flow%20information%20enquiry';
      } else if (appType === 'boe') {
        this.mailHref = 'mailto:buildover@gww.com.au?Subject=Building%20over%20easement%20enquiry';
      } else if (appType === 'chm') {
        this.mailHref = 'mailto:camsapplications@gww.com.au?Subject=Check%20meters%20application%20enquiry';
      } else if (appType === 'usr') {
        this.mailHref = 'mailto:technicalenquiries@gww.com.au?Subject=Urgent%20sewer%20repair%20notice%20enquiry';
      } else if (appType === 'cmp') {
        this.mailHref = 'mailto:complexplumbing@gww.com.au?Subject=Complex%20plumbing%20enquiry';
      } else if (appType === 'lnd-w') {
        this.mailHref = 'mailto:designs@gww.com.au?Subject=Development%20works%20application%20enquiry';
      }
    } else {
      if (appType === 'srp') {
        this.mailHref = 'mailto:Developer.Services@gww.com.au?Subject=Single%20residential%20plumbing%20enquiry';
      } else if (appType === 'sdai') {
        this.mailHref = 'mailto:Developer.Services@gww.com.au?Subject=Sewer%20details%20and/or%20asset%20information%20enquiry';
      } else if (appType === 'SRA') {
        this.mailHref = `mailto:Developer.Services@gww.com.au?Subject= Ref# ${this.DAMSApplicationId} - Servicing%20Requirements%20Advice%20Enquiry`;
      } else if (appType === 'pfi') {
        this.mailHref = 'mailto:Developer.Services@gww.com.au?Subject=Pressure%20and%20flow%20information%20enquiry';
      } else if (appType === 'boe') {
        this.mailHref = 'mailto:Developer.Services@gww.com.au?Subject=Building%20over%20easement%20enquiry';
      } else if (appType === 'chm') {
        this.mailHref = 'mailto:Developer.Services@gww.com.au?Subject=Check%20meters%20application%20enquiry';
      } else if (appType === 'usr') {
        this.mailHref = 'mailto:Developer.Services@gww.com.au?Subject=Urgent%20sewer%20repair%20notice%20enquiry';
      } else if (appType === 'cmp') {
        this.mailHref = 'mailto:Developer.Services@gww.com.au?Subject=Complex%20plumbing%20enquiry';
      } else if (appType === 'lnd-w') {
        this.mailHref = 'mailto:Developer.Services@gww.com.au?Subject=Development%20works%20application%20enquiry';
      }
    }
  }

  ok() {
    this.router.navigate(['/']);
  }

  redirect() {
    this.countDownTimer = 5;

    const _redirect = () => {
      const url: string = environment.calendlyUrl;
      window.location.href = `${ url }?a1=${ this.DAMSApplicationId }`;
    };

    const beginCountdown = () => {
      const interval = setInterval(() => {
        this.countDownTimer = this.countDownTimer - 1;

        if (this.countDownTimer === 1) {
          clearInterval(interval);
          _redirect();
        }
      }, 1000);
    };

    beginCountdown();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/application-confirmation/application-confirmation.component.ts